module.exports = __webpack_public_path__ + "static/media/internal.c5dbbff6.svg";